import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function TwitterRouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (window.twq) window.twq('track', 'PageView');
  }, [pathname, search]);
  return null;
}
